import inputDefaultDark from '../../../common/algorithms/input-default-dark';

const condition = (ratio) => ratio >= 1.5;

const dark = (params) => inputDefaultDark(params, { condition });

export default dark;
